export const DEFAULT_FORMAT_REQUIREMENTS = 'Ensure the picture is clear, properly aligned, and not tilted.'
